/* eslint-disable import/no-unused-modules */
import styled from 'styled-components';

import { Button } from '@/ui/Button';
import { LearningCardProps, LearningCard } from '@/administration/pages/Journey/common/atoms/LearningCard/LearningCard';
import { PARENT_JOURNEY_ID_SEARCH_KEY } from '@/store/v2/journeys/useLearningJourneyBreadcrumbs';
import type { UpNextAllItemsLockedInformerProps } from '@/features/journey/admin/atoms/UpNextAllItemsLockedInformer';
import { UpNextAllItemsLockedInformer } from '@/features/journey/admin/atoms/UpNextAllItemsLockedInformer';

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  border-radius: 8px;
  padding: 32px;
  gap: 8px;
  width: 100%;
`;

const TitleStyled = styled.div`
  ${({ theme }) => theme.typography.title3};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const CardWrapperStyled = styled.div`
  padding: 24px 0;
`;

type JourneyUpNextLearningProps = {
  isActionActive: boolean;
  /** When true, show the “all upcoming locked” message instead of the card and CTA. */
  allUpcomingItemsLocked?: boolean;
  /** Optional when {@link allUpcomingItemsLocked} is true (card is not shown). */
  learningCardProps?: LearningCardProps;
  actionHref: string;
  parentJourneyId?: number;
} & Pick<UpNextAllItemsLockedInformerProps, 'unlockAt'>;

export const JourneyUpNextLearning = ({
  isActionActive,
  learningCardProps,
  actionHref,
  parentJourneyId,
  unlockAt,
  allUpcomingItemsLocked,
}: JourneyUpNextLearningProps): JSX.Element | null => {
  if (allUpcomingItemsLocked) {
    return (
      <RootStyled>
        <TitleStyled>Up next</TitleStyled>
        <CardWrapperStyled>
          <UpNextAllItemsLockedInformer unlockAt={unlockAt} />
        </CardWrapperStyled>
      </RootStyled>
    );
  }

  if (!learningCardProps) return null;

  return (
    <RootStyled>
      <TitleStyled>Up next</TitleStyled>
      <CardWrapperStyled>
        <LearningCard {...learningCardProps} />
      </CardWrapperStyled>
      <Button
        variant={isActionActive ? 'primary' : 'neutral'}
        icon="arrow-right"
        $iconPosition="end"
        to={{
          pathname: actionHref,
          search: `${PARENT_JOURNEY_ID_SEARCH_KEY}=${parentJourneyId}`,
        }}
      >
        Continue learning
      </Button>
    </RootStyled>
  );
};
